// this will not change anymore so it's faster to put this as constant in UI
const OvertimeRateType = [
    {rateType: 1, description: 'Base + Premium'},
    {rateType: 2, description: 'Base Only'},
    {rateType: 3, description: 'Premium Only'}
]

export default OvertimeRateType